import React from "react";
import { Sidebar, MobileTopbar } from "@/components/Sidebar";

export const AppShell = ({ children, title, subtitle, actions }) => {
  return (
    <div className="min-h-screen flex bg-[#fbfdfc]">
      <Sidebar />
      <div className="flex-1 min-w-0 flex flex-col">
        <MobileTopbar />
        <main className="flex-1 p-5 md:p-8 max-w-[1400px] w-full mx-auto">
          {(title || actions) && (
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-6 md:mb-8 animate-fade-in-up">
              <div>
                {title && (
                  <h1 className="font-heading text-2xl md:text-3xl font-semibold tracking-tight text-ink-900">
                    {title}
                  </h1>
                )}
                {subtitle && (
                  <p className="text-sm text-ink-600 mt-1">{subtitle}</p>
                )}
              </div>
              {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
            </div>
          )}
          {children}
        </main>
      </div>
    </div>
  );
};
